import type { SVGProps } from 'react';
const SvgPadding = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#padding_svg__a)">
      <path
        fill="currentColor"
        d="M3 3v18h18V3H3Zm16 16H5V5h14v14ZM11 7h2v2h-2V7ZM7 7h2v2H7V7Zm8 0h2v2h-2V7Z"
      />
    </g>
    <defs>
      <clipPath id="padding_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgPadding;
